import styled from "styled-components";
import { FlexContainers, Paragraph2 } from "../../components";

export const BackLinkStyled = styled(FlexContainers.FlexRowStart)`
  ${Paragraph2} {
    font-weight: 600;
  }

  svg {
    margin-right: 12px;
  }

  a,
  button {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  button {
  }
`;
